import { render } from "./BehaviorFeature.vue?vue&type=template&id=22c362b0&scoped=true"
import script from "./BehaviorFeature.vue?vue&type=script&lang=js"
export * from "./BehaviorFeature.vue?vue&type=script&lang=js"

import "./BehaviorFeature.vue?vue&type=style&index=0&id=22c362b0&lang=scss&scoped=true"

import exportComponent from "/home/jenkins/workspace/qixiao_410_6413_沙箱云前端生产环境/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22c362b0"]])

export default __exports__